/** 
 * Files and styles imported here will take effect site-wide
 * Use carefully to avoid bloating bundle sizes
 */

 //Import base CSS for header/nav bar
import '../scss/base.scss';
import 'promise-polyfill/src/polyfill';
//Import and bind JS functions used for opening the nav, ajax searching, handling scrolling and hiding the nav etc
import {toggleSidebar, navScrollHeaderHide} from './nav.js';

document.addEventListener('scroll', navScrollHeaderHide, {passive: true});

//Gets width of users screen and puts it into a hidden input
//on any and all enquiry forums on the page



//Include slidein newsletter widget
import {handleSlideInNews} from "../../Widgets/NewsletterSlideIn";


import {checkWidth, lazyLoadFooter, newsletterSignUp} from '../../Core/scripts/utilities';
window.lazyLoadFooter = lazyLoadFooter;
window.newsletterSignUp = newsletterSignUp;


document.addEventListener('DOMContentLoaded', () => {
    checkWidth();
    // ADDED_2025_PERFORMANCE_REFACTOR - check element exists before adding listener
    const slideInForm = document.querySelector('.newsletter-slide-in-form');
    if (slideInForm) {
        slideInForm.addEventListener('submit',
            function(event) {
                event.preventDefault();
                handleSlideInNews(event);
            }
        )
    }
    // END ADDED_2025_PERFORMANCE_REFACTOR
}, false);


import '../scripts/shortlist';